export default __webpack_public_path__ + "756ebcda04032cb3d92307d1b9900a95.svg";